import { Button, message, Modal } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { SPTableWithModel } from '@/index';
import { Api } from '@cui/req';
import { XSelectTree } from './../XSelectTree';
import { useModalShow } from './effects';

import styles from './index.module.less';
import { postRecordList } from '@/api/npi.api';

export const ModalConfig = ({
  btnProps,
  modalTitle,
  treeData,
  checkedAble,
  onTreeCheckedChange,
  handleTableItemChecked,
  productType,
  checkedMapValue = {}
}: any) => {
  const { showModal, modalContrulor, setShowModal } = useModalShow();
  const [currentClickTreeNode, setCuClickTreeNode] = useState(null);
  // const [cuMdTemplateNumber, setMdTemplateNumber] = useState(null);
  const [cuMdTemplateNumber, setMdTemplateNumber] = useState<string>("''");
  const handleTreeNodeClick = async (v: any) => {
    const noChild = !(v.children && v.children.length > 0);
    if (v?.level && noChild) {
      setCuClickTreeNode(v);
      const { md_bbom_template_line_id } = v || {};
      const listRes = await postRecordList({
        app_id: 'master_data',
        model_id: 'md_bbom_template_line',
        md_bbom_template_line_id,
      })
      // TODO 这里未来要改多选
      const { data = [] } = listRes || {};
      const { bd_feature_type_number } = data[0] || {};
      // setMdTemplateNumber(bd_feature_type_number);
      if (bd_feature_type_number) {
        const str = bd_feature_type_number.split(',').map((el: string) => `'${el}'`).join(',');
        setMdTemplateNumber(str);
      } else {
        setMdTemplateNumber("''");
      }
      // return;
    }
    // message.warning('目前只支持03级过滤条件配置!')
  };

  const clickFilter = () => {
    if (treeData) {
      setShowModal(true);
    } else {
      message.warning('当前品类下无产品结构定义');
    }
  };
  return (
    <>
      {/* <Button
        {...Object.assign(
          {
            className: styles['default_btn_wrap'],
            children: '设置过滤',
            type: 'text',
          },
          btnProps || {},
        )}
        onClick={modalContrulor(true)}
      /> */}
      <Button className={styles.default_btn_wrap} icon={<SettingOutlined />} type="link" onClick={clickFilter}>
        设置过滤
      </Button>
      {showModal &&
        <Modal
          visible
          title={modalTitle || '过滤条件配置'}
          footer={null}
          width='74vw'
          onCancel={modalContrulor(false)}
          maskClosable={false}
        >
          <div className={styles['modal_content_wrap']}>
            <div className={styles['select_wrap']}>
              <XSelectTree
                value={treeData}
                onCheckedChange={onTreeCheckedChange}
                checkedAble={checkedAble}
                currentClickNode={currentClickTreeNode}
                handleNodeClick={handleTreeNodeClick}
              />
            </div>
            <div className={styles['table_wrap']}>
              <SPTableWithModel
                API={{
                  FetchAPI: Api
                }}
                columns={[{
                  dataIndex: 'feature_type'
                }, {
                  dataIndex: 'name'
                }]}
                filter={`(feature_type in (${cuMdTemplateNumber}) AND product_type = '${currentClickTreeNode?.product_type}')`}
                moduleID="bd_feature"
                namespaceID="base"
                defaultSize="small"
                search={false}
                rowSelection={{
                  selectedRowKeys: checkedMapValue[currentClickTreeNode?.id]?.checkedKeyList || [],
                  onChange: (checkedKeyList: any[], checkedRecordList: any[]) => handleTableItemChecked && handleTableItemChecked({
                    key: currentClickTreeNode?.id || currentClickTreeNode?.key,
                    keyNode: currentClickTreeNode,
                    checkedKeyList,
                    checkedRecordList
                  })
                }}
              />
            </div>
          </div>
        </Modal>
      }
    </>
  );
};
